/** The signed-in person's own settings (access tokens for MCP clients, their devices), then the company's coaching switch. */
import { AccessTokens } from '../components/AccessTokens'
import { CoachingSwitch } from '../components/CoachingSwitch'
import { useFounder } from './context'
import { RemoveDevices } from './RemoveDevices'

export function AccountPage() {
  const f = useFounder()
  return (
    <>
      <div className="page-head">
        <div>
          <span className="crumb">{f.state.world.founder.name}</span>
          <h1>Account</h1>
        </div>
      </div>
      <p className="aside page-sub">
        Signed in as <b>{f.me.person.email}</b>. These settings are yours alone; your team has their own.
      </p>
      <AccessTokens api={f.api} />
      <RemoveDevices />
      <CoachingSwitch api={f.api} company={f.state.world.founder.name} />
    </>
  )
}
